import React, { useCallback, useMemo, useState } from 'react';
import SignaturePadModal from '../app/components/signature/signaturePad';

export function useSignaturePadModal() {
  const [isOpen, setIsOpen] = useState(false);
  const [mode, setMode] = useState('add');
  const [initialImage, setInitialImage] = useState('');
  const [saveCallback, setSaveCallback] = useState(() => {});
  const [cancelCallback, setCancelCallback] = useState(() => {});
  const [loading, setLoading] = useState(false); // Add loading state

  const SignaturePadModalComponent = useCallback(
    () => (
      <SignaturePadModal
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        mode={mode}
        initialImage={initialImage}
        onSave={(imageDataUrl,setIsOpen) => saveCallback(imageDataUrl, setLoading,setIsOpen)} 
        onCancel={() => cancelCallback()}
        loading={loading} 
      />
    ),
    [isOpen, mode, initialImage, saveCallback, cancelCallback, loading]
  );

  const openSignaturePad = useCallback(
    ({ mode = 'add', image = '', onSave = () => {}, onCancel = () => {} }) => {
      setMode(mode);
      setInitialImage(image);
      setSaveCallback(() => onSave); 
      setCancelCallback(() => onCancel);
      setIsOpen(true);
      setLoading(false); 
    },
    []
  );

  return useMemo(
    () => ({
      SignaturePadModal: SignaturePadModalComponent,
      openSignaturePad,
    }),
    [SignaturePadModalComponent, openSignaturePad]
  );
} 